import { team } from '@/services/axios'
export const profile = {
    namespaced: true,
    state: {
        camposPersonalizados: {},
        typeCampos: [],
        setCampos: {},
        teams: {
            value: null,
            load: false,
            data: [],
            params: {
                q: '',
                per_page: 10000,
                page: 1
            },
            pageTotal: 3
        },
    },

    getters: {
        getCamposPersonalizados(state) { return state.camposPersonalizados },
        getTypeCampos(state) { return state.typeCampos },
        setTypeCampos(state) { return state.setCampos },
        getTeams(state) { return state.teams.data },
        getTeamsLoad(state) { return state.teams.load }
    },

    mutations: {
        SET_CAMPO_PERSONALIZADO (state, payload) {
            state.camposPersonalizados = payload
        },

        SET_TYPE_CAMPOS (state, payload) {
            state.typeCampos = payload
        },

        SET_CAMPOS (state, payload) {
            state.setCampos = payload
        },

        SET_TEAMS (state, payload) {
            if(payload.data) {
                const array = payload.data.concat(state.teams.data)
                //remove valores repetidos
                state.teams.data = array.filter((item, index) => {
                    return index === array.findIndex((obj) => obj.id === item.id && obj.label === item.label);
                });
                state.teams.params.page = payload.page + 1
                state.teams.pageTotal = payload.last
            }
            else {
                state.teams.data = []
                return
            }
        },
        SET_TEAMS_SEARCH(state) {
            state.teams.data = []
            state.teams.params.page = 1
            state.teams.pageTotal = 3
        },

        SET_SEARCH (state, payload) {
            state.teams.params.q = payload
        },

        SET_LOAD (state, payload) {
            state.teams.load = payload
        }
    },

    actions: {
        async loadDataTeans({state, commit}, data) {
            /**
             * retorna Se não existir nenhuma busca e se todos os dados ja estiverem ok
             */
            if(data.hasData && state.teams.params.q == '') return
            /**
             * limpa os dados quando o clique do select2 é ativo fora do input dele reiniciando tudo
             */
            if(data.click && state.teams.params.q != '') {
                await commit('SET_SEARCH', '')
                commit('SET_TEAMS_SEARCH')
            }
            /**
             * retorna se a proxima página não tiver nada a mostrar
             */
            if(state.teams.params.page > state.teams.pageTotal) return
            commit('SET_LOAD', true)
            let teamsData = []
            let last = state.teams.pageTotal
            let page = state.teams.params.page
            if(data && !data.search && !data.click) {
                commit('SET_TEAMS', {data: null})
                //para supervisor traz mais de um time
                if(data?.data?.length) {
                    for(const key in data.data) {
                        teamsData.push({label: data.data[key].name, value: data.data[key].team_id})
                    }
                }
                //para outros usuários é somente adicionado
                else teamsData.push({label: data.data.name, value: data.data.id})
                page = 0

            } else {
                await team.getAll('/search', state.teams.params).then(res => {
                    for(const data in res.data.data) {
                        teamsData.push({label: res.data.data[data].name, value: res.data.data[data].id})
                    }
                    last = res.data.last_page
                })
            }
            let payload = {data: teamsData, last: last, page: page}

            commit('SET_TEAMS', payload)
            commit('SET_LOAD', false)
        },

        async setSearch({ commit }, val) {
            await commit('SET_SEARCH', val)
            commit('SET_TEAMS_SEARCH')
        },

        setCamposPersonalizados ({commit}, payload) {
            let typeCampos = []
            let setCampos = {}
            payload.forEach(item => {
                item.value = ''
                if(item.field.value) {
                    item.value = item.field.value.value ? item.field.value.value : ''
                }
                /**
                 * filtrar campos para ativar as tags com os tipos textearea, input, select, tell, email
                 * @params (typeCampos) 
                 */
                typeCampos.push({
                    id: item.field_id,
                    campos: item.field.slug.replace(/-/g, '_'),
                    [item.field.slug.replace(/-/g, '_')]: item.value,
                    value: item.value,
                    required: item.field.required,
                    type: item.field.type,
                    setRequired: false
                })
                typeCampos.map(res => {
                    setCampos[res.campos] = res[res.campos]
                })
            })
            commit('SET_CAMPO_PERSONALIZADO', payload)
            commit('SET_TYPE_CAMPOS', typeCampos)
            commit('SET_CAMPOS', setCampos)
        },

        setAtualizeCamposPersonalizados ({commit} ,payload) {
            payload[1].map(item => {
                if(payload[0][item.campos]) {
                    var tipo = Object.keys(payload[0])
                    tipo.forEach(element => {
                        if(item.campos == element) {
                            item[element] = payload[0][element]
                            item.value = payload[0][element]
                            item.setRequired = false
                        }
                    });
                } else {
                    if(item.required == true) {
                        item.setRequired = true
                    }
                }
            })
            commit('SET_TYPE_CAMPOS', payload[1]);
        }
    }
}